<template>
  <div>
    <veaDialog
      title="变更记录"
      class="reCHForm"
      :show.sync="show"
      :before-close="closeDialog"
    >
      <div class="tool">
        <el-form ref="form" :model="form" label-width="60px">
          <el-row :gutter="5">
            <el-col :span="24">
              <el-form-item label="变更内容">
                <el-input v-model="form.contant"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="变更日期">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    v-model="form.bd"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">至</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    v-model="form.ed"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item> </el-col
            ><el-col span="6">
              <el-form-item label="变更类型">
                <el-select clearable  v-model="form.type" placeholder="请选择类型">
                  <el-option
                    v-for="item in tboptions.lx"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="变更人">
                <el-select clearable  v-model="form.fzr" placeholder="请选择负责人">
                  <el-option
                    v-for="item in tboptions.fzr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <el-button
                type="primary"
                size="small"
                class="search"
                @click="_Query_tpr_xm_dy_change()"
              >
                搜索
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        ref="table"
        border
        stripe
        v-loading="tableload"
        highlight-current-row
        :data="tableData"
        tooltip-effect="dark"
        header-row-class-name="table_header"
        :header-row-style="{ 'text-align': 'center' }"
        @selection-change="handleSelectionChange"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%"
        height="320"
        @cell-mouse-enter="cellMouseEneter"
        @mouseleave.native="toolsHideFn()"
      >
        <!-- 悬浮：工具栏 -->
        <div
          v-show="toolShow"
          ref="tool"
          class="my_tools"
          :class="{ hide: !toolExpend }"
          :style="toolStyle"
          @mouseenter="toolsMouseEnter()"
        >
          <div v-show="toolExpend" class="tools_box">
            <!-- <slot name="tools" /> -->
            <el-button
              v-for="(el, index) in btns"
              :key="index"
              :style="[
                { background: el.ys },
                { color: '#ffffff' },
                { 'border-radius': '4px' },
                { 'border-color': el.ys }
              ]"
              size="small"
              @click="actionClick(el.actionName)"
              >{{ el.label }}</el-button
            >
          </div>
          <div
            class="hide_btn"
            :title="toolExpend ? '隐藏' : '展开'"
            v-preventReClick
            @click="toolExpend = !toolExpend"
          >
            <svg-icon icon-class="right" />
          </div>
        </div>
        <el-table-column
          v-for="(item, i) in th"
          :key="i"
          :label="item.chnname"
          :width="item.width"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="scope.row.isEdit">
              <el-switch
                v-if="item.switch"
                :disabled="item.disabled"
                v-model="scope.row[item.fieldname]"
                active-color="#1890FF"
                inactive-color="#999999"
              ></el-switch>
              <el-select clearable 
                v-else-if="item.select"
                v-model="scope.row[item.fieldname]"
                placeholder="请选择状态"
              >
                <el-option
                  v-for="item in tboptions[item.op || item.fieldname]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                v-else-if="item.number"
                v-model="scope.row[item.fieldname]"
                oninput="value=value.replace(/\D/g,'')"
              />
              <el-date-picker
                v-else-if="item.datetime"
                type="date"
                placeholder="选择日期"
                v-model="scope.row[item.fieldname]"
                style="width: 100%;"
              ></el-date-picker>
              <el-input v-else v-model="scope.row[item.fieldname]" />
            </template>

            <span v-else>{{
              item.switch
                ? scope.row[item.fieldname]
                  ? '是'
                  : '否'
                : scope.row[item.fieldname]
            }}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="'操作'"
          width="100"
          fixed="right"
          class-name="operateColumn"
        >
          <template slot-scope="scope">
            <span
              class="table_operate"
              :title="scope.row.isEdit ? '保存' : '删除'"
              @click="
                tableOperate(
                  scope.$index,
                  scope.row,
                  scope.row.isEdit ? 'save' : 'delete'
                )
              "
            >
              <svg-icon
                :icon-class="
                  scope.row.isEdit ? 'advancedQuerySave' : 'advancedQueryDelete'
                "
              />
            </span>
            <span class="divid">|</span>
            <span
              class="table_operate"
              :title="scope.row.isEdit ? '取消编辑' : '编辑'"
              @click="
                tableOperate(
                  scope.$index,
                  scope.row,
                  scope.row.isEdit ? 'cancel' : 'edit'
                )
              "
            >
              <svg-icon
                :icon-class="
                  scope.row.isEdit ? 'advancedQueryCancel' : 'advancedQueryEdit'
                "
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
    </veaDialog>
    <filelist
      ref="filelist"
      :ty="0"
      :choos="{ name: '项目调研变更' }"
      :pautoid="tablerow.autoid"
    />
  </div>
</template>

<script>
import { Query_tpr_xm_dy_change, Edit_tpr_xm_dy_change } from '@api/api.js'
import filelist from '@components/filelist.vue'
export default {
  props: {
    tboptions: {
      // 下拉选项
      type: Object,
      default: () => {}
    }
  },
  components: {
    // file,
    filelist
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {},
      show: false,
      title: '',
      form: {
        contant: '',
        value2: '',
        bd: '',
        ed: '',
        type: '',
        fzr: ''
      },
      th: [
        {
          chnname: '所属模块',
          fieldname: 'module',
          op: 'mk',
          width: '100',
          select: true
        },
        {
          chnname: '功能类型',
          fieldname: 'type',
          op: 'lx',
          select: true
        },
        {
          chnname: '变更内容',
          fieldname: 'contant'
        },
        {
          chnname: '任务说明',
          fieldname: 'instructions'
        },
        {
          chnname: '负责人',
          fieldname: 'fzr',
          width: '100',
          select: true
        },
        {
          chnname: '周',
          fieldname: 'week',
          width: '100',
          number: true
        },
        {
          chnname: '计划开始日期',
          fieldname: 'bd',
          width: '100',
          datetime: true
        },
        {
          chnname: '计划结束日期',
          fieldname: 'ed',
          width: '100',
          datetime: true
        },
        {
          chnname: '附件',
          fieldname: 'hasfile',
          width: '100',
          switch: true,
          disabled: true
        }
      ],
      initData: [], //保存表格接口返回的原始数据
      tableData: [],
      tableload: false,
      toolShow: true, // 是否显示工具
      toolExpend: true, // 是否展开工具
      toolStyle: {}, // 工具样式（位置）
      color: [
        '#409eff',
        '#67c23a',
        '#e6a23c',
        '#f56c6c',
        '#1B6AAA',
        '#6FB3E0',
        '#629B58',
        '#E59729',
        '#D15B47',
        '#D6487E',
        '#7461AA',
        '#FEE188'
      ],
      toolsBtn: [
        {
          label: '附件',
          actionName: 'fj'
        }
      ],
      tablerow: {},
      curRow: {}, // 修改中的行
      tableChange: true
    }
  },
  computed: {
    btns() {
      return this.getColor(this.toolsBtn)
    }
  },
  watch: {
    show(val) {
      if (val) {
        this._Query_tpr_xm_dy_change()
      }
    }
  },
  methods: {
    _Query_tpr_xm_dy_change() {
      const { contant, value2, bd, ed, type, fzr } = this.form
      Query_tpr_xm_dy_change({
        mautoid: this.$route.query.autoid,
        contant,
        value2,
        bd,
        ed,
        type,
        fzr
      }).then(res => {
        if ((res.error = '0')) {
          res.list.forEach(e => {
            e.isEdit = false
            if (e.bd.indexOf('T')) e.bd = e.bd.split('T')[0]
            if (e.ed.indexOf('T')) e.ed = e.ed.split('T')[0]
          })
          this.initData = JSON.parse(JSON.stringify(res.list))
          this.tableData = res.list
        } else {
          this.initData = []
          this.tableData = []
        }
      })
    },
    closeDialog() {
      this.show = false
    },
    // 循环添加颜色的方法
    getColor(array) {
      let i = 0
      if (array.length > 0) {
        array.forEach((item, index) => {
          if (i == 12) {
            i = 0
          }
          item.ys = this.color[i]
          i++
        })
      }
      return array
    },
    // enter-left
    cellMouseEneter(row, column, cell, event) {
      this.$nextTick(() => {
        const { offsetHeight, offsetTop } = cell
        const _p = this.$refs.tool.parentElement // 父级元素['hidden-columns']
        if (this.toolShow === false) this.toolShow = true
        // 计算 需要固定列的总宽度
        const tst =
          cell.parentElement.parentElement.parentElement.parentElement.scrollTop
        // 公式 = 100% - 默认固定列[多选+序号] - 额外 - 固定列框宽
        // _p.style.maxWidth = `calc(100% - 110px - 20px - ${fw}px)`;
        _p.style.maxWidth = `calc(100% - 110px - 20px )`
        _p.style.height = offsetHeight + 'px'
        let header = document.getElementsByTagName('thead')
        _p.style.top = offsetTop + header[0].offsetHeight - tst + 'px'
        console.log(this.toolShow, _p.style.top, 'this.toolShow')

        this.tablerow = row
      })
    },
    // leave
    toolsHideFn() {
      this.toolShow = false
      this.toolExpend = true
    },
    // 工具栏 鼠标移入事件
    toolsMouseEnter() {
      this.toolShow = true
      this.toolExpend = true
    },
    // 悬浮按钮点击事件
    actionClick(name) {
      console.log(name)
      this.$refs.filelist.show = true
    },
    labelHead: function(h, { column, $index }) {
      let l = column.label.length
      let f = 12
      column.minWidth = f * (l + 2) //加上一个文字长度
      return h('div', { class: 'table-head', style: { width: '100%' } }, [
        column.label
      ])
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },

    // 表格 操作方法
    tableOperate(index, row, type) {
      console.log('tableOperate', { index, row, type })
      // 编辑
      if (type == 'edit') {
        row.isEdit = true
        this.$forceUpdate()
      } else if (type == 'cancel') {
        row.isEdit = false
        // 还原数据: 刷选上次接口返回的数据
        this.initData.forEach(el => {
          if (row.autoid == el.autoid) {
            let obj = JSON.parse(JSON.stringify(el))
            Object.assign(row, obj)
            this.$forceUpdate()
          }
        })
      } else if (type == 'save') {
        // 修改
        row.isactive = 1
        row.isadd = false
        Edit_tpr_xm_dy_change(row).then(res => {
          this.$message.success('修改成功')
          row.isEdit = false
          this._Query_tpr_xm_dy_change() // 获取列表
        })
      } else if (type === 'delete') {
        // 删除
        this.$confirm('您确定更要删除该记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          row.isEdit = false
          Edit_tpr_xm_dy_change({
            autoid: row.autoid,
            isactive: 0,
            isadd: false
          }).then(res => {
            this.$message.success('删除成功')
            this._Query_tpr_xm_dy_change() // 获取列表
          })
        })
      }
    },
    handleSelectionChange(val) {
      this.tableChange = val
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-dialog__wrapper.reCHForm {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(1200px, 700px);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    .el-dialog__body {
      padding: 20px 20px 0 20px;
      .el-table {
        // 工具栏
        .hidden-columns {
          visibility: inherit;
          z-index: 9999;
          right: 7px;
          // margin-top: 3px;
          .my_tools {
            height: 100%;
            min-width: 45px;
            max-width: 100%;
            // padding: 0 0 0 20px;
            padding: 0 25px 0 20px;
            background: linear-gradient(
              to right,
              rgba(0, 0, 0, 0) 0%,
              #eee 30px,
              #ccc 100%
            );
            position: relative;
            .tools_box {
              @include wh(100%, 100%);
              display: flex;
              align-items: center;
              overflow: auto;
              .el-button {
                // 工具栏 内容字体大小随表单（后台控制）PS：目前只用到button，后期有需要其他再另行补充
                // @include _font;
                width: 100%;
                height: 100%;
                font-size: 12px;
                // display: flex;
                // flex-direction: column;
                // align-items: center;
                svg {
                  display: block;
                  margin: 2px auto;
                }
              }
            }
            // 隐藏按钮
            .hide_btn {
              position: absolute;
              top: 0;
              right: 0;
              @include wh(20px, 100%);
              @include flexCenter;
              border-left: 1px solid transparent;
              transition: all 0.2s;
              &:hover {
                // background: #ccc;
                background: #aaa;
                cursor: pointer;
                // border-left-color: #FFF;
                color: #fff;
              }
            }
          }
          .hide {
            transition: all 0.3s;
            svg {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }
}
</style>
